import './actionButtons.less';

import React from 'react';

import { translator } from 'core/localization/localization';
import { observer } from 'mobx-react';
import { ModelValidator, ValidationState } from 'framework/mobx-integration';
import { AntButton } from 'controls/react/ant/antButton';
import { NavigationStore } from '../../../framework/navigationStore';
import b_ from 'b_';

const i = translator({});
const b = b_.with('form-action-buttons');

export interface ActionButtonsProps {
	mode?: string;
	update?: boolean;

	actionButtonLabel?: string;

	className?: string;

	onSave: string | ((ev: React.MouseEvent<HTMLButtonElement>) => void);
	onCancel: string | (() => void);
	popOnCancel?: boolean;
	saveDisabled?: boolean;
	disabledReason?: string;
	showSave?: boolean;
	disabled?: boolean;
	validator?: ModelValidator<any>;
	cancelText?: string;
	fieldLabel?: (field: string) => string;
}

export const ActionButtons = observer((props: ActionButtonsProps) => {
	const showSave = props.showSave ?? true;

	let saveDisabled = props.saveDisabled ?? false;
	if (props.validator) {
		saveDisabled = saveDisabled || props.validator.validationState != ValidationState.Valid;
	}

	let mode = props.mode || 'create';
	if (props.update === true) {
		mode = 'update';
	}

	const className = props.className ?? '';

	let onCancel = typeof props.onCancel == 'function' ? props.onCancel : null;
	if (props.popOnCancel && !onCancel) {
		onCancel = () => NavigationStore.pop();
	}

	const fieldLabel = props.fieldLabel ?? ((x) => x);

	return (
		<div className={b(className)}>
			{showSave && (
				<AntButton
					className={b('button')}
					type={'primary'}
					disabled={saveDisabled || props.disabled}
					title={
						props.validator?.errors.map((x) => fieldLabel(x.field) + ' - ' + x.errors.join('\r\n')).join('\r\n') ?? ''
					}
					onClick={typeof props.onSave == 'function' ? props.onSave : null}
					href={typeof props.onSave == 'string' ? props.onSave : null}
				>
					{props.actionButtonLabel || i(mode, { capitalize: true })}
				</AntButton>
			)}
			<AntButton
				className={b('button')}
				onClick={onCancel}
				href={typeof props.onCancel == 'string' ? props.onCancel : null}
				disabled={props.disabled}
			>
				{props.cancelText ?? i('Cancel')}
			</AntButton>
		</div>
	);
});
